import styled from 'styled-components'
import Wrapper from 'common/wrapper'
import { Typography } from 'common/typography'
import Image from 'next/legacy/image'

const FinalRewardStyled = styled.section`
  padding-block-start: 40px;
  padding-block-end: 40px;
  h2 {
    font: var(--headline4);
    margin-block-end: 16px;
    color: var(--secondary);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-shadow: 0px 0px #00000000;
    background-image: linear-gradient(258.75deg, #43B1C8 31.33%, #9989EB 48.42%, #D97FD1 59.35%, #F582B2 65.56%);
  }
  .content-container {
    background: #1F1F3A;
    border-radius: 8px;
    padding: 16px;
    p {
      color: var(--white);
      margin: 8px 0;
    }
  }
  .image-container {
    display: flex;
    justify-content: center;
  }
  @media(min-width: 768px) {
    h2 {
      font: var(--headline3);
    }
    .content-container {
      margin-block-start: 0px;
    }
  }
  @media(min-width: 1024px) {
    padding-block-start: 80px;
    padding-block-end: 80px;
    h2 {
      font: var(--headline2);
    }
    .image-container {
      min-width: 508px;
      min-height: 423px;
      position: absolute;
      bottom: 0;
      right: 40px;
    }
    .final-reward-container {
      display: flex;
      min-height: 363px;
      box-sizing: border-box;
      background: #1F1F3A;
      border-radius: 8px;
      padding: 24px;
      position: relative;
    }
    .content-container {
      background: transparent;
      max-width: 40%;
      padding: 0px;
    }
  }
  @media(min-width: 1366px) {
    .final-reward-container {
      padding: 40px;
    }
  }
`

function FinalReward() {
  return (
    <FinalRewardStyled>
      <Wrapper maxWidth={1200}>
        <div className="final-reward-container">
          <div className="image-container">
            <Image src="/images/scholarships/reward.png" alt="Recompensa final" width="508" height="423" />
          </div>
          <div className="content-container">
            <Typography as="h2">
              Recibe un curso sorpresa
            </Typography>
            <p>
              Al finalizar todos los pasos obtendrás acceso a un curso sorpresa, todo gracias al gran esfuerzo y dedicación que has demostrado al llegar hasta acá.
            </p>
            <p>Tambien podras de beneficios exclusivos en futuras dinamicas.</p>
          </div>
        </div>
      </Wrapper>
    </FinalRewardStyled>
  )
}

export default FinalReward
